import React from 'react';
import styled from 'styled-components/macro';
import px2vw from '../utils/px2vw';

const TitleContainer = styled.div`
    width: ${px2vw(1440)};
    height: ${px2vw(500)};
    min-height: 280px;
    justify-content: center;
    align-items: left;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-image: url(${(props) => props.image});
    @media screen and (max-width: 600px) {
        position: relative;
        top: ${px2vw(150)};
        background-size: cover;
    }
`;

const Title = styled.div`
    /* margin-top: 234px; */
    margin-left: 13.8889%;;
    width: 80%;
    height: ${px2vw(60)};
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: bold;
    line-height: ${props => props.theme.titleLineHeight};
    color: #FFFFFF;
    word-wrap: wrap;
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(44)
    }};  
`;

const PageTitle = ((props) => {
    return (
        <TitleContainer image={props.image}>
            <Title>{props.title}</Title>
        </TitleContainer>
    )
});

export default PageTitle
